import {Link, withStyles} from '@material-ui/core';
import Button from "@components/common/button/Button";
import * as UserActions from '@services/user/user.actions';
import * as React from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, RouteComponentProps} from 'react-router-dom';
import TranslateNew from "@translate/TranslateNew";
import CordovaContext from 'src/cordovaContext';
import { getOS } from '@helpers/osDetection';
import {InviteContainerStyle as styles} from './invite.style';
import SelectLanguage from "@components/common/language/SelectLanguage";


const tn:TranslateNew = TranslateNew.getInstance();



interface IState {
  token:string;
  hasSentData:boolean;
  useWeb:boolean;
}

interface IProps extends RouteComponentProps<IRouteParams> {
  storeInviteToken: (token: string) => void;
  user: any;
  classes:any;
}

interface IRouteParams {
  token?: string;
}

class PInviteContainer extends React.Component<IProps, IState> {

  constructor(props:any) {
    super(props);

    const { match: { params: { token } } } = props;

    let hasSentData = false;
    if (token && token.length > 0) {
      props.storeInviteToken(token);
      hasSentData = true;
    }

    this.state = {
      token:(token?token:""),
      hasSentData,
      useWeb:false,
    };
  }

  public componentDidUpdate(oldProps:IProps) {
    if (oldProps.match !== this.props.match) {
      const { match: { params: { token } } } = this.props;
      if(token && token.length > 0 && !this.state.hasSentData) {
        this.props.storeInviteToken(token);
        this.setState({hasSentData:true});
      }
    }
  }

  public render() {
    return (
      <CordovaContext.Consumer>
      {
      (cordovaApp) =>
        { return (cordovaApp
          ?this.renderApp()
          :this.renderWeb());
        }
      }
      </CordovaContext.Consumer>
    );
  }

  private renderApp() {
    return (<Redirect to={('/signup/'+this.state.token)} />);
  }

  private renderWeb() {
    const os = getOS();
    const style = this.props.classes;
    if (os === "ANDROID") {
      return (<Route path='/' component={() =>
      { window.location.href = 'https://play.google.com/store/apps/details?id=app.varannanvecka'; return null;}}/>);
    } else if (os === "IOS") {
      return (<Route path='/' component={() =>
        { window.location.href = 'https://apps.apple.com/us/app/varannan-vecka/id1618305857'; return null;}}/>);
    } else if (this.state.useWeb) {
      return (<Redirect to={('/signup/'+this.state.token)} />);
    }
    return (
      <div className={style.page}>
        <div className={style.languageSelect}>
          <SelectLanguage/>
        </div>
        <div className={style.contentBox}>
          <Link href={"https://apps.apple.com/us/app/varannan-vecka/id1618305857"}>
            <img src={require('src/images/badge-apple.png')} />
          </Link>
          <Link href={"https://play.google.com/store/apps/details?id=app.varannanvecka"}>
            <img src={require('src/images/badge-google.png')} />
          </Link>
          <Button variant="contained" color="primary"  onClick={() => this.setState({useWeb:true})}>
            {tn.lang.landingUseBroswer}
          </Button>
        </div>
      </div>
    );
  }

}

function mapStateToProps(state: any) {
  return {
    language: state.user.language,
    errorMessage: state.user.errorMessage.message,
    errorTime: state.user.errorMessage.id,
  };
}

const mapDispatchToProps = {
  storeInviteToken: UserActions.storeInviteToken,
};

const InviteContainer = withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PInviteContainer));

export default InviteContainer;



// WEBPACK FOOTER //
// ./src/containers/invite/invite.container.tsx